/**
 * src/features/router/router.state.js
 * 
 * Estado del router
 */

import {
    signal
} from '@core/signal.js'
import {
    logger
} from '@shared/utils/logger.js'

/**
 * Signal que contiene la ruta actual de la aplicación.
 */
export const currentPath = signal(window.location.pathname)

/**
 * Navega a una nueva ruta.
 * @param {string} path - La nueva ruta (ej. '/about').
 */
export function navigate(path) {
    window.history.pushState(null, null, path)
    currentPath.set(path)
    logger.info(` Navegando a: ${path}`)
}

/**
 * Reemplaza la ruta actual (sin crear entrada en el historial).
 * @param {string} path - La nueva ruta.
 */
export function replace(path) {
    window.history.replaceState(null, null, path)
    currentPath.set(path)
    console.log('[ROUTER] Reemplazando ruta a:', path)
}

/**
 * Vuelve a la página anterior.
 */
export function goBack() {
    window.history.back()
}

/**
 * Avanza a la siguiente página.
 */
export function goForward() {
    window.history.forward()
}

// Escuchar eventos de navegación del navegador (botones atrás/adelante)
window.addEventListener('popstate', () => {
    currentPath.set(window.location.pathname)
})

// Interceptar todos los <a href> internos para evitar recarga completa
document.addEventListener('click', e => {
    const anchor = e.target.closest('a[href]')
    if (!anchor) return

    const href = anchor.getAttribute('href')
    // Ignorar: externos, mailto, tel, hash, download, target="_blank"
    if (
        !href ||
        href.startsWith('http') ||
        href.startsWith('mailto') ||
        href.startsWith('tel') ||
        href.startsWith('#') ||
        anchor.hasAttribute('download') ||
        anchor.getAttribute('target') === '_blank'
    ) return

    e.preventDefault()
    navigate(href)
})